import { Routes } from '@angular/router';

// '/users'
export const USERS_ROUTES: Routes = [
    {
        path: 'change-password',
        title: 'Change Password',
                loadComponent: () =>
                    import('../../app-layout/change-password/change-password.component').then(m => m.ChangePasswordComponent),
    },
    {
        path: 'password-changed',
                loadComponent: () =>
                    import('../../app-layout/password-changed/password-changed.component').then((m) => m.PasswordChangedComponent),
    },
    {
        path: 'users',
        title: 'Users',
        loadComponent: () => import('./users.component').then((m) => m.UsersComponent),
        data: {
            icon: 'groups',
            module: 'USER',
        },
        children: [
            {
                path: 'change-password',
                title: 'Change Password',
                loadComponent: () =>
                    import('../../app-layout/change-password/change-password.component').then(m => m.ChangePasswordComponent),
            },
            {
                path: 'password-changed',
                loadComponent: () =>
                    import('../../app-layout/password-changed/password-changed.component').then((m) => m.PasswordChangedComponent),
            },
            {
                path: 'add',
                title: 'Add New User',
                loadComponent: () => import('./user-add/user-add.component').then((m) => m.UserAddComponent),
                data: {
                    icon: 'groups',
                }
            },
            {
                path: ':id/edit',
                title: 'Edit User',
                data: {
                    icon: 'groups',
                },
                loadComponent: () => import('./user-edit/user-edit.component').then((m) => m.UserEditComponent),
            },
            {
                path: ':userId/change-password',
                loadComponent: () =>
                    import('../../app-layout/change-password/change-password.component').then((m) => m.ChangePasswordComponent),
            },
            {
                path: ':id',
                title: 'User View',
                data: {
                    icon: 'groups',
                },
                loadComponent: () => import('./user-view/user-view.component').then((m) => m.UserViewComponent),
            },
            {
                path: '',
                pathMatch: 'full',
                data: {
                    reuse: true,
                },
                loadComponent: () => import('./user-list/user-list.component').then((m) => m.UserListComponent),
            },
        ]
    }
];
